module.exports = __webpack_public_path__ + "Roboto-MediumItalic.fa183350bf6b814ae552.ttf";


//////////////////
// WEBPACK FOOTER
// /app/~/roboto-fontface/fonts/Roboto/Roboto-MediumItalic.ttf
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-MediumItalic.ttf
// module chunks = 13